import { jsxs as a, jsx as s } from "react/jsx-runtime";
import { R as g, I as h } from "../../../../item-hfCP3RsN.js";
import { c as u } from "../../../../clsx-OuTLNxxd.js";
import "../../../../button.types-AwV8CUDS.js";
import { I as j } from "../../../../icon-BnqXyiyH.js";
import "../../icon/iconsList.js";
import "react";
import "../../tag/tag.js";
import "../../carousel/carousel.js";
import "../input/input.js";
import "../checkbox/checkbox.js";
import "../../toast/toast.context.js";
import "../../../../map-5H_GMJF6.js";
const w = "_title_ej2xw_37", f = "_text_ej2xw_41", r = {
  "radio-group": "_radio-group_ej2xw_29",
  "group-label": "_group-label_ej2xw_34",
  title: w,
  text: f,
  "has-error": "_has-error_ej2xw_48",
  "error-message": "_error-message_ej2xw_51"
};
function I({
  children: i,
  defaultValue: m,
  label: o,
  helperContent: e,
  errorMessage: t,
  disabled: l,
  onChange: p,
  onBlur: c,
  value: _,
  name: n
}) {
  const x = !!t, d = !!(o ?? e);
  return /* @__PURE__ */ a(
    g,
    {
      name: n,
      onValueChange: p,
      defaultValue: m,
      className: u(r["radio-group"], t && r["has-error"]),
      disabled: l,
      onBlur: c,
      value: _,
      children: [
        d && /* @__PURE__ */ a("div", { className: r["group-label"], children: [
          o && /* @__PURE__ */ s("label", { className: r.title, children: o }),
          e && /* @__PURE__ */ s("p", { className: r.text, children: e })
        ] }),
        i,
        x && /* @__PURE__ */ a("p", { className: r["error-message"], children: [
          /* @__PURE__ */ s(j, { name: "error-warning-fill", color: "error" }),
          t
        ] })
      ]
    }
  );
}
I.Item = h;
export {
  I as Radio
};
